export enum SlotGameEvent {
    SPIN_START = 'onSlotGameSpinStart',
    REELS_STARTED = 'onSlotGameReelsStarted',
    SPIN_TIME_LAPSED = 'onSlotGameSpinTimeLapsed',
    ROUND_RESULT_OBTAINED = 'onSlotGameRoundresultObtained',
    STOP_REQUESTED = 'onSlotGameStopRequested',
    SPIN_STOP = 'onSlotGameSpinStop',
    REELS_STOPPED = 'onSlotGameReelsStopped',
    MULTI_WIN_SHOWN = 'onSlotGameMultiWinShown',
    WINLINE_WIN_SHOWN = 'onSlotGameWinlineWinShown',
    SCATTER_WIN_SHOWN = 'onSlotGameScatterWinShown',
    CASCADE_WIN_SHOWN = 'onSlotGameCascadeWinShown',

    BONUS_GAME_WIN_SHOWN = 'onSlotGameBonusGameWinShown',
    BONUS_GAME_WIN_REJECTED = 'onSlotGameBonusWinRejected',
    BONUS_GAME_STARTED = 'onSlotGameBonusGamePlayStarted',
    BONUS_GAME_COMPLETE = 'onSlotGameBonusGamePlayComplete',

    FREE_SPIN_WIN_SHOWN = 'onSlotGameFreeSpinWinShown',
    FREE_SPIN_ROUND_STARTED = 'onSlotGameFreeSpinRoundStarted',
    FREE_SPIN_START = 'onSlotGameFreeSpinStart',
    FREE_SPIN_ROUND_COMPLETE = 'onSlotGameFreeSpinRoundComplete',

    BIG_WIN_SHOWN = 'onSlotGameBigWinShown',
    SPIN_RESULT_READY = 'onSlotGameSpinResultReady',
    ROUND_COMPLETE = 'onSlotGameRoundComplete'
}
